import {ColumnItemBuilder} from "./column-item";
import {CfUIFolder} from "../api/attachment";

export const FolderTableColumns = [
  new ColumnItemBuilder('files.columns.name', (a: CfUIFolder, b: CfUIFolder) => (a.name.value || '').localeCompare((b.name.value || '')), null),
  new ColumnItemBuilder('files.columns.owner', (a: CfUIFolder, b: CfUIFolder) => (a.owner?.fullName || '').localeCompare((b.owner?.fullName || '')), null),
  new ColumnItemBuilder('files.columns.date_upd', (a: CfUIFolder, b: CfUIFolder) => a.dateUpd - b.dateUpd, null),
  new ColumnItemBuilder('files.columns.file_size', (a: any, b: any) => (a.fileSize || '').localeCompare((b.fileSize || '')), null),
];
